import { combineReducers } from 'redux';
import session from './session.reducer';

const reducer = combineReducers({
	session
});

export default reducer;
